import { render, staticRenderFns } from "./GenJinList.vue?vue&type=template&id=0ad071b8&"
import script from "./GenJinList.vue?vue&type=script&lang=js&"
export * from "./GenJinList.vue?vue&type=script&lang=js&"
import style0 from "./GenJinList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ad071b8')) {
      api.createRecord('0ad071b8', component.options)
    } else {
      api.reload('0ad071b8', component.options)
    }
    module.hot.accept("./GenJinList.vue?vue&type=template&id=0ad071b8&", function () {
      api.rerender('0ad071b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/GenJinList.vue"
export default component.exports